import { ApiProperty } from "@nestjs/swagger";
import { IsAlphanumeric, IsNotEmpty, IsNumber, IsOptional } from "class-validator";

export class CodeListSOItemRequest {
   
    saleOrderItemId: number;
    constructor(saleOrderItemId: number){
        this.saleOrderItemId = saleOrderItemId
    }
}